import { SvgIcon, type SvgIconProps } from '../../layout/SvgIcon';

export const UserGroupGradientIcon24: React.FC<SvgIconProps> = (props) => (
    <SvgIcon width="24" height="24" fill="none" {...props}>
        <path
            fill="url(#a)"
            fillRule="evenodd"
            d="M17.379 6.629a3 3 0 1 1 4.242 4.242 3 3 0 0 1-4.242-4.242Zm2.121.621a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
            clipRule="evenodd"
        />
        <path
            fill="url(#b)"
            fillRule="evenodd"
            d="M9.348 7.348a3.75 3.75 0 1 1 5.304 5.303 3.75 3.75 0 0 1-5.304-5.303ZM12 7.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z"
            clipRule="evenodd"
        />
        <path
            fill="url(#c)"
            fillRule="evenodd"
            d="M2.379 6.629A3 3 0 1 1 6.62 10.87 3 3 0 0 1 2.38 6.63ZM4.5 7.25a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
            clipRule="evenodd"
        />
        <path
            fill="url(#d)"
            d="M8.25 17a.75.75 0 0 0 .75-.75c0-.365-.044-.725-.13-1.073A5.747 5.747 0 0 0 7.515 16.4.75.75 0 0 0 8.25 17Z"
        />
        <path
            fill="url(#e)"
            fillRule="evenodd"
            d="M4.5 13.25a3 3 0 0 0-3 3 .75.75 0 0 1-1.5 0 4.5 4.5 0 0 1 8.87-1.073A5.747 5.747 0 0 0 7.515 16.4a.753.753 0 0 1-.015-.151 3 3 0 0 0-3-3Zm11.985 3.151A5.75 5.75 0 0 1 17.75 20a.75.75 0 0 1-1.5 0 4.25 4.25 0 0 0-8.5 0 .75.75 0 0 1-1.5 0 5.75 5.75 0 0 1 1.265-3.599A.75.75 0 0 0 9 16.25c0-.365-.044-.725-.13-1.073a5.75 5.75 0 0 1 6.26 0A4.5 4.5 0 0 0 15 16.25a.75.75 0 0 0 1.485.151Zm0 0c.01-.049.015-.1.015-.151a3 3 0 0 1 6 0 .75.75 0 0 0 1.5 0 4.5 4.5 0 0 0-8.87-1.073 5.752 5.752 0 0 1 1.355 1.224Z"
            clipRule="evenodd"
        />
        <path
            fill="url(#f)"
            d="M15 16.25a.75.75 0 0 0 1.485.151 5.768 5.768 0 0 0-1.355-1.224A4.5 4.5 0 0 0 15 16.25Z"
        />
        <defs>
            <linearGradient
                id="a"
                x1="0"
                x2="24"
                y1="18.625"
                y2="18.625"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#153BFF" />
                <stop offset="1" stopColor="#F3C" />
            </linearGradient>
            <linearGradient
                id="b"
                x1="0"
                x2="24"
                y1="18.625"
                y2="18.625"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#153BFF" />
                <stop offset="1" stopColor="#F3C" />
            </linearGradient>
            <linearGradient
                id="c"
                x1="0"
                x2="24"
                y1="18.625"
                y2="18.625"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#153BFF" />
                <stop offset="1" stopColor="#F3C" />
            </linearGradient>
            <linearGradient
                id="d"
                x1="0"
                x2="24"
                y1="18.625"
                y2="18.625"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#153BFF" />
                <stop offset="1" stopColor="#F3C" />
            </linearGradient>
            <linearGradient
                id="e"
                x1="0"
                x2="24"
                y1="18.625"
                y2="18.625"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#153BFF" />
                <stop offset="1" stopColor="#F3C" />
            </linearGradient>
            <linearGradient
                id="f"
                x1="0"
                x2="24"
                y1="18.625"
                y2="18.625"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#153BFF" />
                <stop offset="1" stopColor="#F3C" />
            </linearGradient>
        </defs>
    </SvgIcon>
);
